/**
 * Edge function error messages.
 *
 * supabase-js rejects any non-2xx response from a function with the generic
 * "Edge Function returned a non-2xx status code" and hands back the untouched
 * Response on `error.context`. Our functions put a plain-English reason in the
 * body ("You've reached today's limit for voice notes"), so read that instead
 * of showing the member the transport-level wording.
 */

const FALLBACK = "Something went wrong. Please try again.";

export async function readFunctionError(error, fallback = FALLBACK) {
  if (!error) return fallback;

  const response = error.context;
  if (typeof response?.json !== "function") return error.message || fallback;

  try {
    const body = await response.clone().json();
    return body?.error || error.message || fallback;
  } catch {
    return error.message || fallback;
  }
}

/**
 * Wraps functions.invoke so callers get `{ success, data, error }` with a
 * message worth showing on screen.
 */
export async function invokeFunction(supabase, name, options, fallback) {
  const { data, error } = await supabase.functions.invoke(name, options);

  if (error) {
    return { success: false, error: await readFunctionError(error, fallback) };
  }
  if (data?.error) {
    return { success: false, error: data.error };
  }

  return { success: true, data };
}
